import { heroStats } from "@/mocks/content";

const jumpTo = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-28 md:pt-36 pb-16 md:pb-24">
      <div
        className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-primary-200/40 blur-3xl animate-glow-pulse"
        aria-hidden="true"
      />
      <div
        className="absolute top-40 -right-20 w-[360px] h-[360px] rounded-full bg-accent-200/40 blur-3xl animate-glow-pulse"
        aria-hidden="true"
      />

      <div className="relative px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 font-label text-xs mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500" aria-hidden="true" />
              片单每周更新 · 四大内容板块
            </div>

            <h1 className="font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
              红桃影视最新影片与热播榜，
              <span className="text-primary-600">伦理片、韩剧、短剧、高分电影</span>
              一次说清
            </h1>

            <p className="mt-6 text-sm md:text-base leading-relaxed text-foreground-600 max-w-xl">
              这里不是播放器，而是一份帮你省时间的片库指南。我们把平台上的最新影片、伦理片、韩剧、短剧和高分电影按题材整理成清晰的片单，配有评分、集数与一句话看点，让你在想看点什么的时候，能更快做决定。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => jumpTo("library")}
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-label text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-search-eye-line" aria-hidden="true" />
                进入片库检索
              </button>
              <button
                type="button"
                onClick={() => jumpTo("ranking")}
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 font-label text-sm hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-fire-line" aria-hidden="true" />
                查看热播榜 TOP 10
              </button>
            </div>

            <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-6 max-w-lg">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-heading text-2xl font-bold text-foreground-950">
                    {stat.value}
                  </dt>
                  <dd className="font-label text-xs text-foreground-500 mt-1">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border border-background-200 bg-background-100 aspect-[5/6] w-full animate-float-y">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20illustration%20of%20a%20vintage%20movie%20theater%20interior%20at%20dusk%2C%20deep%20crimson%20velvet%20curtains%20and%20warm%20amber%20projector%20beams%20crossing%20the%20dark%20hall%2C%20glowing%20golden%20dust%2C%20film%20noir%20atmosphere%2C%20rich%20red%20and%20ochre%20palette%2C%20painterly%20textured%20editorial%20poster%20art%2C%20dramatic%20contrast%2C%20no%20text&width=1000&height=1200&seq=htys-hero-main&orientation=portrait"
                alt="红桃影视片库主题插画：暖色调影院与投影光束"
                className="w-full h-full object-top"
              />
              <div
                className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent"
                aria-hidden="true"
              />
              <div className="absolute bottom-5 left-5 right-5 text-background-50">
                <p className="font-label text-[11px] tracking-[0.2em]">NOW SHOWING</p>
                <p className="font-heading text-lg font-semibold mt-1">红桃影视 · 本周片单</p>
              </div>
            </div>

            <div className="absolute -bottom-5 -left-3 md:-left-6 bg-background-50 border border-background-200 rounded-xl px-4 py-3 shadow-none w-[190px]">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-fire-fill" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-label text-[10px] text-foreground-500">今日热播 No.1</p>
                  <p className="font-heading text-sm font-semibold text-foreground-950">冬日的信</p>
                </div>
              </div>
              <div className="flex items-center gap-1 mt-2.5">
                <span className="font-heading text-sm font-bold text-accent-700">9.1</span>
                <span className="font-label text-[10px] text-foreground-400">站内评分</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}